module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_microsoft_365-small-e0c0ae71a534ccd58fbb709d970e200a.png";